import { Injectable } from '@angular/core';
import { ICorporatePartner } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AuxiliaryNavigationAemItem,
  HeaderFooterMachCore,
  SignupLoginAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { take } from 'rxjs/operators';
import { LoginFacadeSupportService } from './login-facade-support.service';

@Injectable({
  providedIn: 'root'
})
export class LoginFacadeService extends LoginFacadeSupportService {
  loadHeaderFooter(): void {
    this.APP_NAME = this._config.get('APP');
    this.initializeSessionTimeout();
    this.showSessionTimeoutModal = false;
    this.makeGetDashBrdData();
    this.loadHeaderFooterContent();
  }

  initializeSessionTimeout(): void {
    this.appConfigService
      .getConfigValue('HEADER', 'APP_SESS_TIME_OUT')
      .pipe(take(1))
      .subscribe((value) => {
        this.APP_SESS_TIME_OUT = Number.parseInt(value, 10);
      });
  }

  makeGetDashBrdData(): void {
    this.getUserSessionDetails();
    this.registerServiceWorker();
  }

  registerServiceWorker(): void {
    this.userData.getAuthConfigContent().subscribe(async (response) => {
      this.userSession.registerServiceWorker(response);
    });
  }

  setAuxiliaryNavigation(data: HeaderFooterMachCore): void {
    const auxiliaryNavArr: AuxiliaryNavigationAemItem[] = Array.from(
      data.header.auxiliaryNavigation.values()
    );
    for (const item of auxiliaryNavArr) {
      if (item && (item as { id: string }).id) {
        const key = item['id'];
        this.checkItemInList(key, data);
      }
    }
    this.loginArr.forEach((item) => {
      if (item.id === 'login') {
        this.assignLoginDetails(item);
      }
      if (item.id === 'signup') {
        this.assignSignupDetails(item);
      }
      if (item.id === 'accountrecovery') {
        this.assignAccountRecoveryDetails(item);
      }
    });
    this.signupLoginContent$.next({
      signupLoginContent: {
        signupLabel: this.signupLabel,
        loginLabel: this.loginLabel,
        signupLink: this.signupLink,
        loginLink: this.loginLink
      },
      toolTipContent: {
        tooltipSignUpContent: this.tooltipSignUpContent,
        tooltipLoginContent: this.tooltipLoginContent,
        tooltipAccountRecoveryContent: this.tooltipAccountRecoveryContent
      },
      milesLabel: this.milesLabel
    });
  }

  loadHeaderFooterContent(): void {
    this.contentService
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((data: HeaderFooterMachCore) => {
        this.showProfileSelector();
        this.getSessionTimeoutContent(data);
        const partner = this.getCorporatePartnerFromCookie();
        this.setMilesLabelContent(data, partner);
        this.setAuxiliaryNavigation(data);
        this.checkSignUpLoginToolTip();
      });
  }

  getSessionTimeoutContent(data: HeaderFooterMachCore): void {
    let slimheaderLogoUrl = '';
    if (data.logo !== undefined && data.logo.slimheaderLogoUrl !== undefined) {
      slimheaderLogoUrl = data.logo.slimheaderLogoUrl;
    }
    if (data.sessionTimeoutMessage) {
      this.updateSessionTimeoutDescription(data);
      this.updateSessionTimeoutMessage(data);
    }
    this.updateSessionTimeoutContent({
      slimheaderLogoUrl: slimheaderLogoUrl
    });
  }

  assignLoginDetails(item: AuxiliaryNavigationAemItem): void {
    const loginItem = item as SignupLoginAem;
    this.tooltipLoginContent = loginItem.loginTooltipLabel
      ? loginItem.loginTooltipLabel
      : this.tooltipLoginContent;
    this.loginLabel = loginItem.rightnavLabel ? loginItem.rightnavLabel : '';
    this.loginLink = loginItem.rightnavLink ? loginItem.rightnavLink : '';
  }

  getCorporatePartnerFromCookie(): ICorporatePartner {
    const accountCookie = this.cookieHelper.getCookieValue('account');
    if (accountCookie) {
      const parseAccount = JSON.parse(accountCookie);
      const partnerId =
        parseAccount?.businessAccountOptionsList?.partnerId || 'default';
      return {
        showBusinessMilesLabel: partnerId !== 'default'
      } as ICorporatePartner;
    }
    return {} as ICorporatePartner;
  }
}
